<template>
  <i 
    class="lyf-ui-icon lyf-icon" 
    :class="['icon-' + icon]"
    :style="{
      color,
      fontSize: size + 'px'
    }"
  ><slot></slot></i>
</template>

<script>
export default {
  name: 'LyfIcon',
  props: {
    icon: { 
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 18
    },
    color: {
      type: String,
      default: ''
    }
  },
}
</script>

<style scoped>
.lyf-ui-icon {
  font-family: "lyf-icon" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
